module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article-w540.91bba925.jpg";